import { Component } from 'react'
import { connect } from 'react-redux'
import { actions as UIActions, selectors as UISelectors } from 'data/ui'
const { CONNECTED, DISCONNECTED } = UISelectors.CONNECTION_STATUSES_TYPE

class ConnectionChecker extends Component {
  onlineListener = null
  offlineListener = null

  componentDidMount() {
    this.onlineListener = window.addEventListener('online', () => {
      this.sendConnectionStatus(CONNECTED)
    })
    this.offlineListener = window.addEventListener('offline', () => {
      this.sendConnectionStatus(DISCONNECTED)
    })

    this.sendConnectionStatus(
      window.navigator.onLine ? CONNECTED : DISCONNECTED
    )
  }

  sendConnectionStatus(status) {
    this.props.setConnectionStatus({
      service: 'navigator',
      status,
    })
  }

  componentWillUnmount() {
    if (this.onlineListener) {
      window.removeEventListener('online', this.onlineListener)
    }
    if (this.offlineListener) {
      window.removeEventListener('offline', this.offlineListener)
    }
  }

  render() {
    return false
  }
}

export default connect(
  null,
  { ...UIActions }
)(ConnectionChecker)
